import { IArticle, IRESTPageWrapper } from "online-services-types";
import { APIFetch } from "src/APIFetch";
import { displayError } from "src/util/error";
import { getUsingOpenSearch } from "../../util/localstorage";

export async function getArticleAndFileByIdEquipmentAndChapter(
  articleId: string,
  equipmentId: string,
  chapter: string
) {
  const article = await getArticleByIdEquipmentAndChapter(articleId || "", equipmentId || "", chapter || "");

  if (article) {
    const htmlFiles = article.files.filter((articleFile) => articleFile.type === "XML" || articleFile.type === "HTML");

    if (htmlFiles.length === 1) {
      return {
        articleId: article.id,
        fileId: htmlFiles[0].id,
      };
    }
  }

  return null;
}

async function getArticleByIdEquipmentAndChapter(articleId: string, equipmentId: string, chapter: string) {
  try {
    const resource = getUsingOpenSearch().toLowerCase() === "true" ? "documents/documentsnew" : "documents/documents";
    const articles = await new APIFetch<IRESTPageWrapper<IArticle>>(resource).get(undefined, {
      chapter,
      equipment: equipmentId,
      id: articleId,
    });

    if (articles.results.length !== 1) {
      return null;
    }

    return articles.results[0];
  } catch (error) {
    displayError(error);
    return null;
  }
}
